export const WHATSAPP_CONTACT_URL =
  "https://api.whatsapp.com/send?phone=+5548991929692&text=Ol%C3%A1,%20gostei%20da%20ferramenta%20de%20certificados.%20Como%20fa%C3%A7o%20para%20usar%20a%20plataforma%20no%20meu%20evento?";

export const openWhatsAppContact = () => {
  window.open(WHATSAPP_CONTACT_URL, "_blank");
};

export const goToLogin = () => {
  window.location.href = "/login";
};
